import { isEmptyObject } from "../../../utils/tests";
import { LmpPredictedLineupsQuery } from '../types';

/**
 * typeguard for LmpPredictedLineupsQuery
 * @param LmpPredictedLineupsQuery object passed to transformer
 */
export const isValidLmpPredictedLineups = (obj: LmpPredictedLineupsQuery): boolean => Boolean(obj?.data?.predictedLineupLmp && !isEmptyObject(obj.data.predictedLineupLmp));
